'use strict';

const {
	googleInsightsArgsResolver,
	googleKeywordsInsightsArgsResolver,
	appleInsightsArgsResolver,
	bingInsightsArgsResolver,
	overviewInsightsArgsResolver,
	ratingInsightsArgsResolver
} = require('../resolvers/insightsArgsResolvers');
const { onDateRangeChanged } = require('../subscriptions/insightsSubscriptions');

const insightsStates = ({ elmWithFilter }) => {
	return [
		{
			name: 'site.Insights',
			url: '/insights',
			requiredPermission: 'permission/location.view',
			redirectTo: 'site.Insights.Overview'
		},
		elmWithFilter({
			name: 'site.Insights.Overview',
			moduleName: 'Insights.Overview.Main',
			url: '/overview?filter&view&from&to',
			argsResolver: [
				'pmtEnvService',
				'$stateParams',
				'pmtFilterService',
				'auth',
				overviewInsightsArgsResolver
			],
			requiredPermission: 'permission/location.view',
			subscriptions: ['$state', $state => [onDateRangeChanged($state)]],
			pageTitle: 'general.insights.page_title'
		}),
		elmWithFilter({
			name: 'site.Insights.Rating',
			moduleName: 'Insights.Rating.Main',
			url: '/rating?filter&view&from&to',
			argsResolver: [
				'pmtEnvService',
				'$stateParams',
				'pmtFilterService',
				'auth',
				ratingInsightsArgsResolver
			],
			requiredPermission: 'permission/location.view',
			subscriptions: ['$state', $state => [onDateRangeChanged($state)]],
			pageTitle: 'general.insights.rating_title'
		}),
		elmWithFilter({
			name: 'site.Insights.Bing',
			moduleName: 'Insights.Bing.Main',
			argsResolver: [
				'pmtEnvService',
				'$stateParams',
				'pmtFilterService',
				'auth',
				bingInsightsArgsResolver
			],
			url: '/bing?view&filter&from&to',
			requiredPermission: 'role/user',
			pageTitle: 'general.shared_navigation.bing_insights',
			subscriptions: ['$state', $state => [onDateRangeChanged($state)]]
		}),
		elmWithFilter({
			name: 'site.Insights.System',
			moduleName: 'Insights.System.Main',
			argsResolver: [
				'pmtEnvService',
				'$stateParams',
				'pmtFilterService',
				googleInsightsArgsResolver
			],
			url: '/system?filter&from&to',
			requiredPermission: 'role/user',
			pageTitle: 'general.shared_navigation.system_insights',
			subscriptions: ['$state', $state => [onDateRangeChanged($state)]]
		}),
		elmWithFilter({
			name: 'site.Insights.Google',
			moduleName: 'Insights.Google.Main',
			argsResolver: [
				'pmtEnvService',
				'$stateParams',
				'pmtFilterService',
				googleInsightsArgsResolver
			],
			url: '/google?view&filter&from&to',
			requiredPermission: 'role/user',
			pageTitle: 'general.shared_navigation.google_insights',
			subscriptions: ['$state', $state => [onDateRangeChanged($state)]]
		}),
		elmWithFilter({
			name: 'site.Insights.Keywords',
			moduleName: 'Insights.Keywords.Main',
			url: '/keywords?filter&from&to',
			requiredPermission: 'role/user',
			pageTitle: 'general.insights.keywords_title',
			argsResolver: ['pmtEnvService', '$stateParams', googleKeywordsInsightsArgsResolver],
			subscriptions: ['$state', $state => [onDateRangeChanged($state)]]
		}),
		elmWithFilter({
			name: 'site.Insights.Apple',
			moduleName: 'Insights.Apple.Main',
			argsResolver: [
				'pmtEnvService',
				'$stateParams',
				'pmtFilterService',
				'auth',
				appleInsightsArgsResolver
			],
			url: '/apple?view&filter&from&to',
			requiredPermission: 'role/user',
			pageTitle: 'general.shared_navigation.apple_insights',
			subscriptions: ['$state', $state => [onDateRangeChanged($state)]]
		}),
		elmWithFilter({
			name: 'site.Insights.Facebook',
			moduleName: 'Insights.Facebook.Main',
			argsResolver: [
				'pmtEnvService',
				'$stateParams',
				'pmtFilterService',
				googleInsightsArgsResolver
			],
			url: '/facebook?view&filter&from&to',
			requiredPermission: 'role/user',
			pageTitle: 'general.shared_navigation.facebook_insights',
			subscriptions: ['$state', $state => [onDateRangeChanged($state)]]
		})
	];
};

module.exports = {
	insightsStates
};
